import { useMutation } from "@tanstack/react-query";
import { deleteConnectUser } from "../../services/users";

export default function useDeleteConnectUser() {
  return useMutation(({ auth0UserId }: { auth0UserId: string }) =>
    deleteConnectUser(auth0UserId)
  );
}
